import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import Home from './pages/Home';
import Photography from './pages/Photography';
import Videography from './pages/Videography';
import GlamBooth from './pages/GlamBooth';
import Packages from './pages/Packages';
import About from './pages/About';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import Faq from './pages/Faq';
import Privacy from './pages/Privacy';
import BookingTerms from './pages/BookingTerms';
import NotFound from './pages/NotFound';
import OurWork from './pages/OurWork';
import EventGallery from './pages/EventGallery';
import AdminLogin from './pages/AdminLogin';
import AuthCallback from './pages/AuthCallback';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import QuoteRequests from './pages/admin/QuoteRequests';
import PackagesAdmin from './pages/admin/PackagesAdmin';
import ServicesAdmin from './pages/admin/ServicesAdmin';
import GalleryAdmin from './pages/admin/GalleryAdmin';
import TestimonialsAdmin from './pages/admin/TestimonialsAdmin';
import FaqsAdmin from './pages/admin/FaqsAdmin';
import SettingsAdmin from './pages/admin/SettingsAdmin';
import EventsAdmin from './pages/admin/EventsAdmin';
import PageContentAdmin from './pages/admin/PageContentAdmin';
import PromoCodesAdmin from './pages/admin/PromoCodesAdmin';
import CategoriesAdmin from './pages/admin/CategoriesAdmin';

const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

const AppRouter = () => {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/glam-booth" element={<PublicLayout><GlamBooth /></PublicLayout>} />
      <Route path="/packages" element={<PublicLayout><Packages /></PublicLayout>} />
      <Route path="/portfolio" element={<PublicLayout><OurWork /></PublicLayout>} />
      <Route path="/previous-events" element={<PublicLayout><OurWork /></PublicLayout>} />
      <Route path="/our-work" element={<PublicLayout><OurWork /></PublicLayout>} />
      <Route path="/our-work/:slug" element={<PublicLayout><EventGallery /></PublicLayout>} />
      <Route path="/photography" element={<PublicLayout><Photography /></PublicLayout>} />
      <Route path="/videography" element={<PublicLayout><Videography /></PublicLayout>} />
      <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
      <Route path="/faq" element={<PublicLayout><Faq /></PublicLayout>} />
      <Route path="/quote" element={<PublicLayout><Quote /></PublicLayout>} />
      <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
      <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />
      <Route path="/booking-terms" element={<PublicLayout><BookingTerms /></PublicLayout>} />
      {/* Legacy → new */}
      <Route path="/services" element={<Navigate to="/packages" replace />} />

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedAdminRoute>
            <AdminLayout />
          </ProtectedAdminRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="quote-requests" element={<QuoteRequests />} />
        <Route path="packages" element={<PackagesAdmin />} />
        <Route path="promo-codes" element={<PromoCodesAdmin />} />
        <Route path="services" element={<ServicesAdmin />} />
        <Route path="gallery" element={<GalleryAdmin />} />
        <Route path="testimonials" element={<TestimonialsAdmin />} />
        <Route path="faqs" element={<FaqsAdmin />} />
        <Route path="events" element={<EventsAdmin />} />
        <Route path="categories" element={<CategoriesAdmin />} />
        <Route path="page-content" element={<PageContentAdmin />} />
        <Route path="settings" element={<SettingsAdmin />} />
      </Route>

      <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
